import { render } from "./politique.vue?vue&type=template&id=eebf4152&scoped=true&class=bg-white%20h-full"
import script from "./politique.vue?vue&type=script&lang=js"
export * from "./politique.vue?vue&type=script&lang=js"

import "./politique.vue?vue&type=style&index=0&id=eebf4152&scoped=true&lang=css"

import exportComponent from "C:\\Users\\gaglo\\OneDrive\\Bureau\\top_chronique\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eebf4152"]])

export default __exports__